var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex mb-1" }, [
      (!_vm.show_product_plans && !_vm.show_company_sub_plans) ||
      (_vm.show_company_sub_plans &&
        this.selected_product_option.plans.length === 1)
        ? _c(
            "button",
            {
              staticClass:
                "btn btn-primary btn-default waves-effect waves-light",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.showProductOptions()
                },
              },
            },
            [
              _c("i", { staticClass: "feather icon-arrow-left" }),
              _vm._v(" Show All Plan Options\n        "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.show_company_sub_plans &&
      this.selected_product_option.plans.length > 1
        ? _c(
            "button",
            {
              staticClass:
                "btn btn-primary btn-default waves-effect waves-light",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.showCompanyOptions()
                },
              },
            },
            [
              _c("i", { staticClass: "feather icon-arrow-left" }),
              _vm._v(" Show All Company Plan Options\n        "),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          { staticClass: "row card-match-height" },
          [
            _vm.show_product_plans
              ? _vm._l(_vm.plan_products, function (plan_product, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "col-12 col-md-6" },
                    [
                      plan_product.plans.length > 1 ||
                      (plan_product.type === "company" &&
                        plan_product.plans[0].sub_plans.length > 1)
                        ? _c("div", { staticClass: "card p-05" }, [
                            _c("div", { staticClass: "card-container" }, [
                              _c("div", { staticClass: "d-inline-flex p-2" }, [
                                _c("div", [
                                  _c("div", {}, [
                                    _c("h3", [
                                      _vm._v(_vm._s(plan_product.title)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  plan_product.type === "company" &&
                                  plan_product.plans.length === 1
                                    ? _c("div", [
                                        _c("p", [
                                          _c("i", {
                                            staticClass: "feather icon-users",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                plan_product.plans[0]
                                                  .num_individuals === 0
                                                  ? "Unlimited"
                                                  : plan_product.plans[0]
                                                      .num_individuals
                                              ) +
                                              " Users"
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  plan_product.lowest_price !== null &&
                                  plan_product.lowest_price !== 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "font-weight-bolder font-size-medium",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            From " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  plan_product.lowest_price,
                                                  _vm.site_tax
                                                )
                                              ) +
                                              " / " +
                                              _vm._s(
                                                plan_product.lowest_price_interval
                                              ) +
                                              "\n                                          "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "mt-05",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        plan_product.description
                                      ),
                                    },
                                  }),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            plan_product.plans[0].plan_features.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "card-body" },
                                  [
                                    _c("plan-features", {
                                      attrs: {
                                        plan_features:
                                          plan_product.plans[0].plan_features,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-footer border-0 bg-white mt-auto",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    class:
                                      "btn mt-1 btn-block mt-auto " +
                                      (_vm.selected_product_id ===
                                      plan_product.id
                                        ? "btn-success"
                                        : "btn-primary"),
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.showPlanOptions(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                  " +
                                        _vm._s(
                                          _vm.selected_product_id ===
                                            plan_product.id
                                            ? "Show Selected Plan Options"
                                            : "Show Plan Options"
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : plan_product.plans.length === 1
                        ? _c("register-plan-card", {
                            attrs: {
                              plan: plan_product.plans[0],
                              selected_plan_id: _vm.selected_plan_id,
                            },
                            on: { "plan-select": _vm.selectPlan },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                })
              : _vm.show_individuals_plans
              ? _vm._l(
                  this.selected_product_option.plans,
                  function (plan, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-12 col-md-6" },
                      [
                        _c("register-plan-card", {
                          attrs: {
                            plan: plan,
                            selected_plan_id: _vm.selected_plan_id,
                          },
                          on: { "plan-select": _vm.selectPlan },
                        }),
                      ],
                      1
                    )
                  }
                )
              : _vm.show_company_plans
              ? _vm._l(
                  this.selected_product_option.plans,
                  function (plan, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-12 col-md-6" },
                      [
                        plan.sub_plans.length > 1
                          ? _c("div", { staticClass: "card p-05" }, [
                              _c("div", { staticClass: "card-container" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-inline-flex p-2" },
                                  [
                                    _c("div", [
                                      _c("div", {}, [
                                        _c("h3", [_vm._v(_vm._s(plan.title))]),
                                      ]),
                                      _vm._v(" "),
                                      plan.type === "company"
                                        ? _c("div", [
                                            _c("p", [
                                              _c("i", {
                                                staticClass:
                                                  "feather icon-users",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    plan.num_individuals === 0
                                                      ? "Unlimited"
                                                      : plan.num_individuals
                                                  ) +
                                                  " Users"
                                              ),
                                            ]),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      plan.lowest_company_price !== null &&
                                      plan.lowest_company_price !== 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-bolder font-size-medium",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            From " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      plan.lowest_company_price,
                                                      _vm.site_tax
                                                    )
                                                  ) +
                                                  " / " +
                                                  _vm._s(
                                                    plan.lowest_company_price_interval
                                                  ) +
                                                  "\n                                         "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "mt-05",
                                        domProps: {
                                          innerHTML: _vm._s(plan.description),
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              plan.sub_plans[0].plan_features.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "card-body" },
                                    [
                                      _c("plan-features", {
                                        attrs: {
                                          plan_features:
                                            plan.sub_plans[0].plan_features,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "card-footer border-0 bg-white mt-auto",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      class:
                                        "btn mt-1 btn-block mt-auto " +
                                        (_vm.checkCurrentPlan(plan)
                                          ? "btn-success"
                                          : "btn-primary"),
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.showCompanyPlans(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.checkCurrentPlan(plan)
                                              ? "Show Selected Plan Options"
                                              : "Show Further Options"
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : [
                              _c("register-plan-card", {
                                attrs: {
                                  plan: plan.sub_plans[0],
                                  selected_plan_id: _vm.selected_plan_id,
                                },
                                on: { "plan-select": _vm.selectPlan },
                              }),
                            ],
                      ],
                      2
                    )
                  }
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.show_company_sub_plans
              ? _vm._l(
                  this.selected_company_sub_plan.sub_plans,
                  function (plan, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-12 col-md-6" },
                      [
                        _c("register-plan-card", {
                          attrs: {
                            plan: plan,
                            selected_plan_id: _vm.selected_plan_id,
                          },
                          on: { "plan-select": _vm.selectPlan },
                        }),
                      ],
                      1
                    )
                  }
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }